import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const ProjectDetailsSection = ({ formData, handleInputChange, errors }) => {
  const budgetRanges = [
    { value: '', label: 'Select Budget Range', disabled: true },
    { value: '0k-5k', label: '$0,000 - $5,000' },
    { value: '5k-15k', label: '$5,000 - $15,000' },
    { value: '15k-30k', label: '$15,000 - $30,000' },
    { value: '30k-50k', label: '$30,000 - $50,000' },
    { value: '50k-100k', label: '$50,000 - $100,000' },
    { value: '100k-250k', label: '$100,000 - $250,000' },
    { value: '250k+', label: '$250,000+' },
    { value: 'discuss', label: 'Prefer to discuss' }
  ];

  const timelineOptions = [
    { value: '', label: 'Select Timeline', disabled: true },
    { value: 'asap', label: 'ASAP (Rush project)' },
    { value: '1-2-months', label: '1-2 months' },
    { value: '3-4-months', label: '3-4 months' },
    { value: '5-6-months', label: '5-6 months' },
    { value: '6-12-months', label: '6-12 months' },
    { value: '12-months+', label: '12+ months' },
    { value: 'flexible', label: 'Flexible timeline' }
  ];

  return (
    <div className="space-y-6">
      <div className="border-b border-border pb-4">
        <h3 className="text-xl font-semibold text-foreground mb-2">Project Details</h3>
        <p className="text-text-secondary text-sm">
          Tell us about your project requirements and expectations
        </p>
      </div>
      <Input
        label="Project Title"
        type="text"
        name="projectTitle"
        placeholder="e.g., E-commerce Platform Development"
        value={formData?.projectTitle}
        onChange={handleInputChange}
        error={errors?.projectTitle}
        required
        description="Give your project a descriptive title"
        className="focus:border-accent"
      />
      <div className="space-y-2">
        <label className="block text-sm font-medium text-foreground">
          Project Description <span className="text-error">*</span>
        </label>
        <textarea
          name="projectDescription"
          rows={6}
          placeholder={`Describe your project in detail. Include:\n• What you want to build or achieve\n• Key features and functionality\n• Target audience\n• Technical requirements\n• Any specific technologies or integrations needed`}
          value={formData?.projectDescription}
          onChange={handleInputChange}
          className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground placeholder-muted-foreground focus:border-accent focus:ring-1 focus:ring-accent transition-colors duration-200 resize-vertical min-h-[120px]"
          required
        />
        {errors?.projectDescription && (
          <p className="text-error text-xs mt-1">{errors?.projectDescription}</p>
        )}
        <p className="text-xs text-text-secondary">
          Minimum 50 characters. Be as detailed as possible to help us understand your needs.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Select
          label="Project Budget"
          options={budgetRanges}
          value={formData?.budget}
          onChange={(value) => handleInputChange({ target: { name: 'budget', value } })}
          error={errors?.budget}
          required
          description="Select your approximate budget range"
        />

        <Select
          label="Preferred Timeline"
          options={timelineOptions}
          value={formData?.timeline}
          onChange={(value) => handleInputChange({ target: { name: 'timeline', value } })}
          error={errors?.timeline}
          required
          description="When do you need this completed?"
        />
      </div>
      <div className="space-y-2">
        <label className="block text-sm font-medium text-foreground">
          Additional Requirements (Optional)
        </label>
        <textarea
          name="additionalRequirements"
          rows={4}
          placeholder={`Any additional information:\n• Specific technologies or frameworks\n• Integration requirements\n• Compliance needs\n• Special considerations`}
          value={formData?.additionalRequirements}
          onChange={handleInputChange}
          className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground placeholder-muted-foreground focus:border-accent focus:ring-1 focus:ring-accent transition-colors duration-200 resize-vertical"
        />
        <p className="text-xs text-text-secondary">
          Include any specific requirements, constraints, or preferences
        </p>
      </div>
    </div>
  );
};

export default ProjectDetailsSection;